import React from 'react';

import type { IconProps } from '@atlaskit/icon/types';

import intentKeepMomentumIconUrl from '../assets/intent-keep-momentum.svg';

export const IntentKeepMomentumIcon = (_props: IconProps) => (
	<img
		src={intentKeepMomentumIconUrl}
		alt=""
		width={32}
		height={32}
		role="presentation"
		aria-hidden="true"
	/>
);
